import { NavigationTabs, type NavigationTabItem } from '@exam-center/components';
import { APP_PERMISSIONS } from '@exam-center/permission';
import { PageHeader } from '@shared/components';
import { usePermission } from '@shared/permissions';
import { useMemo } from 'react';

const TAB_ITEMS: NavigationTabItem[] = [
  {
    value: 'Exam Center Proctor List',
    label: 'ผู้คุมสอบทั้งหมด',
    path: '/admin/exam-proctors/proctors',
    requiredPermission: [APP_PERMISSIONS.ADMIN_PROCTOR_MANAGEMENT.PROCTOR.VIEW],
  },
  {
    value: 'Exam Center Proctor Request List',
    label: 'รายการยื่นคำขออนุมัติผู้คุมสอบ',
    path: '/admin/exam-proctors/requests',
    requiredPermission: [
      APP_PERMISSIONS.ADMIN_PROCTOR_MANAGEMENT.PROCTOR_REQUEST.VIEW,
      APP_PERMISSIONS.ADMIN_PROCTOR_MANAGEMENT.PROCTOR_REQUEST_FIRST_TIER_REVIEW.VIEW,
      APP_PERMISSIONS.ADMIN_PROCTOR_MANAGEMENT.PROCTOR_REQUEST_SECOND_TIER_REVIEW.VIEW,
    ],
  },
  {
    value: 'Activity Log',
    label: 'Activity Log',
    path: '/admin/exam-proctors/activity-log',
    requiredPermission: [APP_PERMISSIONS.ADMIN_PROCTOR_MANAGEMENT.AUDIT_LOG.VIEW],
  },
];

export default function AdminExamCenterProctorHeader() {
  const { permissions } = usePermission();

  const filteredItems = useMemo(
    () =>
      TAB_ITEMS.filter(({ requiredPermission }) => {
        if (!requiredPermission || requiredPermission.length === 0) return true;
        return requiredPermission.some((permission) => permissions.includes(permission));
      }),
    [permissions],
  );

  return <PageHeader title='จัดการผู้คุมสอบ' tabs={<NavigationTabs items={filteredItems} />} />;
}
